<template>
    <div class="container">
        <div class="handle-box-search">
            <div class="handle-box" style="display: flex">
                <el-row class="head-search">
                    <div style="margin: 10px 0; display: flex" class="search-radio fs-big">
                        <div>
                            <div class="title">扣费时间</div>

                            <el-radio-group v-model="order_fixed_time_value" size="small" @change="dataChange">
                                <el-radio label="yesterday" border style="margin-right: 40px">昨天 </el-radio>
                                <el-radio label="between" border style="margin-right: -9px">自定义时间 </el-radio>
                            </el-radio-group>
                        </div>

                        <el-date-picker
                            
                            v-model="search_time"
                            type="datetimerange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            @change="timeChange"
                            style="width: 370px"
                        >
                        </el-date-picker>
                    </div>
                </el-row>
            </div>
            <el-button type="primary" icon="el-icon-search" @click="searchgetCityplatformFee" class="btn1">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
        </div>

        <div class="searchInfo">
            <div style="margin: 20px; display: flex; justify-content: left; color: #606266; margin-left: 10px">
                <div style="margin-right: 50px">抽成订单总数:{{ count }}</div>
                <div style="margin-right: 50px">抽成总额:{{ amount }}</div>
            </div>
            <div>
                <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header">
                    <!-- <el-table-column type="index" label="序号">
                </el-table-column> -->

                    <el-table-column prop="amount" label="金额"> </el-table-column>

                    <el-table-column label="订单号" prop="billno"> </el-table-column>

                    <el-table-column prop="description" label="描述"> </el-table-column>

                    <el-table-column prop="name" label="司机姓名"> </el-table-column>

                    <el-table-column label="电话号" prop="phone"> </el-table-column>

                    <el-table-column label="扣费时间" prop="time_stamp"> </el-table-column>
                </el-table>
            </div>
            <!-- 分页组件 -->
            <div class="pagination">
                <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
            </div>
        </div>
    </div>
</template>

<script>
var _this;

export default {
    components: {},
    data() {
        return {
            order_fixed_time_value: 'yesterday',
            amount: '',
            count: '',
            search_time: [],

            // 存放表格数据
            tableData: [],

            //获取用户列表的数据
            search_data: {
                page: 1,
                limit: 10,
                fixed_array: ''
                // city_code: sessionStorage.getItem("city_code"),
                // city_tag: JSON.parse(localStorage.getItem("city_tag")).city_tag,
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;

        _this.search_data.fixed_array = JSON.stringify([_this.order_fixed_time_value]);

        _this.getCityplatformFee();
    },

    methods: {
        dataChange(val) {
            _this.search_time= [],
            
            console.log(val, 'val'); //yesterday

            if (val == 'between') {
                _this.search_data.fixed_array = JSON.stringify(['between']);
            } else {
                _this.search_data.fixed_array = JSON.stringify([_this.order_fixed_time_value]);
            }
        },
        timeChange(val) {
            _this.order_fixed_time_value= '',
            console.log(val, 'val');

            if (val != null) {
                _this.search_data.fixed_array = JSON.stringify(['between', ..._this.search_time]);
            } else {
                _this.search_data.fixed_array = '';
            }

            // JSON.parse()
        },

        //    btn_isShow(){

        //     if(_this.scope.row.name=''){

        //         _this.btn_isShow = 'false'

        //     }

        //         _this.btn_isShow = 'true'

        //    },

        searchgetCityplatformFee() {
            _this.search_data.page = 1;
            // _this.search_data.city_tag = JSON.parse(
            //   localStorage.getItem("city_tag")
            // ).city_tag;
            _this.getCityplatformFee();
        },

        getCityplatformFee() {
            _this
                .$post('/statistics/getCityplatformFee', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data.result;
                    _this.result_data = res.data;
                    _this.amount = res.data.amount;
                    _this.count = res.data.count;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.getCityplatformFee();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.search-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
    margin-left: 10px;
    margin-top: 10px;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}

.search-box {
    display: flex;
}

.searchBox {
    margin: 10px;
    padding: 30px 0;
    border-radius: 15px;
    background-color: #f5f7fa !important;
    border: 1px solid #dcdfe6;
}

.title {
    display: inline-block !important;
    width: 80px !important;
    text-align: right !important;
    padding-right: 5px !important;
    box-sizing: border-box !important;
    background-color: transparent !important;
    color: #000;
    font-size: 14px;
    margin-left: 10px;
    margin-bottom: 10px;
}

.btn1 {
    margin-left: 10px;
}
</style>